export const postSurvey = {
  success: "The survey has been added successfully!",
};

export const deleteSurvey = {
  success: "The survey has been deleted successfully!",
};

export const editSurvey = {
  success: "The survey has been edited successfully!",
};

export const publishSurvey = {
  success: "The survey has been publish successfully!",
};

export const submitSurvey = {
  success: "The survey has been submitted successfully!",
  failure: "There was an error preventing you from submitting the survey!",
};
